export class ProductInspecReq{
    inspectionId: number;

    
}